import { observer } from 'mobx-react';
import * as React from 'react';
import { equalArrays, includes } from '../../../../../../../../../Collections';
import CompetencyFilterStore from '../Store';
import { CompetencyFilterOptions } from '../Types';

interface Props {
  option: CompetencyFilterOptions;
  competencyFilterStore: CompetencyFilterStore;
}

const checkboxCondition = (
  option: CompetencyFilterOptions,
  competencyFilterStore: CompetencyFilterStore,
) => {
  switch (option.kind) {
    case 'all-competencies':
      return equalArrays(
        competencyFilterStore.state.filter.competencies,
        competencyFilterStore.initialFilterValues.competencies,
      );
    case 'some-competencies':
      return includes(option.name, competencyFilterStore.state.filter.competencies);
    case 'no-competencies':
      return false;
  }
};

const DropdownItem: React.FC<Props> = ({ option, competencyFilterStore }) => (
  <button
    onClick={() => competencyFilterStore.filterAllValues(option)}
    className="flex w-full py-1"
  >
    <div className="flex flex-row bg-white text-gray-700 m-1 justify-between w-full">
      <div className="flex flex-row pr-6">
        <div className="pr-2">
          <div className="flex h-6 items-center">
            <input
              id="offers"
              aria-describedby="offers-description"
              name="offers"
              type="checkbox"
              checked={checkboxCondition(option, competencyFilterStore)}
              className="h-4 w-4 rounded border-gray-300 text-teal-600 focus:ring-teal-600"
              readOnly
            />
          </div>
        </div>
        <div className="text-sm">{option.name}</div>
      </div>
      <div className="text-sm mr-3">{option.count}</div>
    </div>
  </button>
);

export default observer(DropdownItem);
